module.exports = __webpack_public_path__ + "img/impatient.3fa4f7f6.svg";